<template>

<v-select @input="changeSelect($event)"    v-model="selected"   :options="options" :reduce="(option) => option.id"   multiple ></v-select>


</template>


<script>
import vSelect from 'vue-select'
export default{
    name:"MultipleSelect",
    components:{
           "v-select" : vSelect 
    },
    data(){
  return {
    border:true,
    selected: [],
     options: [
      { label: 'One', id: 1 },
      { label: 'Two', id: 2 },
    ]}
    },
    methods:{
      changeSelect(event){
        return false

      }

    }
  
}
</script>
